var _ellipse, _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRouteLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 109,
    viewBox: "0 0 108 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.8944,
    cy: 54.5,
    rx: 53.8944,
    ry: 54.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3595_74211",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 96,
    height: 97
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.8331,
    cy: 54.667,
    r: 47.794,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3595_74211)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.794,
    cy: 54.794,
    r: 47.794,
    fill: "#F6F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.665 75.0166C66.2967 71.7955 72.4436 63.4765 72.4436 53.7218C72.4436 41.1729 62.2707 31 49.7218 31C37.1729 31 27 41.1729 27 53.7218C27 62.5402 32.0236 70.1853 39.3651 73.9514L48.9145 86.6839L57.665 75.0166Z",
    fill: "#6A6A99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.8139,
    cy: 53.686,
    r: 17.7944,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3595_74211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0266 63.2896C57.414 63.2896 57.7306 62.9697 57.7306 62.5714V54.8885H59.5812H59.5843C60.2606 54.8885 60.8078 54.3303 60.8078 53.6404C60.8078 53.2452 60.6295 52.894 60.3497 52.6651L57.9581 50.5484V47.0236C57.9581 46.6128 57.6322 46.2772 57.2264 46.2772H55.714C55.3113 46.2772 54.9823 46.6128 54.9823 47.0236V47.9111L50.7278 44.1417C50.2667 43.734 49.5842 43.734 49.1231 44.1417L39.4642 52.6965C39.08 53.0383 38.9416 53.5871 39.1199 54.0763C39.2982 54.5623 39.7563 54.8885 40.2666 54.8885H42.1172V62.5714C42.1172 62.9697 42.4338 63.2896 42.8212 63.2896H46.9835V57.7014C46.9835 56.9111 47.6106 56.2714 48.3853 56.2714H51.4656C52.2402 56.2714 52.8674 56.9111 52.8674 57.7014V63.2864H57.0266V63.2896Z",
    fill: "#6A6A99"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.1918 43.4001C85.1918 51.0956 79.1983 57.3002 71.8459 57.3002C64.4935 57.3002 58.5 51.0956 58.5 43.4001C58.5 35.7046 64.4935 29.5 71.8459 29.5C79.1983 29.5 85.1918 35.7046 85.1918 43.4001Z",
    fill: "#EE4E4E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2109 39.0322L67.4832 47.76",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6484 39.2002L76.0403 47.5921",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3595_74211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7678,
    height: 19.4521,
    fill: "white",
    transform: "translate(39.043 43.8379)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRouteLogo);
export default __webpack_public_path__ + "static/media/deleteRouteLogo.98c44b9a6b4e902d6b971b616ead42d8.svg";
export { ForwardRef as ReactComponent };